import * as React from "react";
import Tile from "./elements/Tile";
import Top from "./elements/Top";
import Bottom from "./elements/Bottom";
import { Title, Subtitle, Meta } from "./elements/Typo";

type Texts = {
  parts: string;
  notAvailable: string;
  hoverButton?: string;
};

const DEFAULT_TEXTS: Texts = {
  parts: "onderdelen",
  notAvailable: "Nog niet begonnen",
  hoverButton: "Aan de slag"
};

type Props = {
  style?: React.CSSProperties;
  className?: string;
  imageSrc: string;
  title: string;
  description: string;
  id: string;
  onClick?: (id: string) => void;
  texts?: Texts;
  nrOfContentParts: number;
  progress?: number;
  available: boolean;
};

function PartTileUser(
  // @ts-ignore
  {
    style,
    className,
    id,
    imageSrc,
    title,
    description,
    onClick,
    nrOfContentParts,
    texts = DEFAULT_TEXTS,
    progress,
    available
  }: Props,
  ref: any
) {
  return (
    <Tile
      ref={ref}
      style={style}
      className={className}
      onClick={onClick ? () => onClick(id) : undefined}
      progress={progress}
      disabled={!available}
      showProgressBar
    >
      <Top imageSrc={imageSrc} />
      <Bottom
        HoverButtonText={texts.hoverButton}
        topLeft={
          <>
            <Title>{title}</Title>
            <Subtitle>{description}</Subtitle>
          </>
        }
        bottomLeft={
          <Meta>{available ? `${progress}%` : texts.notAvailable}</Meta>
        }
        bottomRight={
          <Meta>
            {nrOfContentParts} {texts.parts}
          </Meta>
        }
      />
    </Tile>
  );
}

export default React.forwardRef(PartTileUser);
